/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiScreeningAlertFilterExpression } from './ApiScreeningAlertFilterExpression';
import {
    ApiScreeningAlertFilterExpressionFromJSON,
    ApiScreeningAlertFilterExpressionFromJSONTyped,
    ApiScreeningAlertFilterExpressionToJSON,
    ApiScreeningAlertFilterExpressionToJSONTyped,
} from './ApiScreeningAlertFilterExpression';

/**
 * New and yet unsaved set of expressions that defines screening alerts search filter
 * @export
 * @interface ApiNewScreeningAlertFilter
 */
export interface ApiNewScreeningAlertFilter {
    /**
     * 
     * @type {string}
     * @memberof ApiNewScreeningAlertFilter
     */
    name: string;
    /**
     * 
     * @type {Array<ApiScreeningAlertFilterExpression>}
     * @memberof ApiNewScreeningAlertFilter
     */
    expressions: Array<ApiScreeningAlertFilterExpression>;
}

/**
 * Check if a given object implements the ApiNewScreeningAlertFilter interface.
 */
export function instanceOfApiNewScreeningAlertFilter(value: object): value is ApiNewScreeningAlertFilter {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expressions' in value) || value['expressions'] === undefined) return false;
    return true;
}

export function ApiNewScreeningAlertFilterFromJSON(json: any): ApiNewScreeningAlertFilter {
    return ApiNewScreeningAlertFilterFromJSONTyped(json, false);
}

export function ApiNewScreeningAlertFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiNewScreeningAlertFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'expressions': ((json['expressions'] as Array<any>).map(ApiScreeningAlertFilterExpressionFromJSON)),
    };
}

export function ApiNewScreeningAlertFilterToJSON(json: any): ApiNewScreeningAlertFilter {
    return ApiNewScreeningAlertFilterToJSONTyped(json, false);
}

export function ApiNewScreeningAlertFilterToJSONTyped(value?: ApiNewScreeningAlertFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'expressions': ((value['expressions'] as Array<any>).map(ApiScreeningAlertFilterExpressionToJSON)),
    };
}

